import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, MenuItem, Checkbox, ListItemText, OutlinedInput, Select, TextField, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { bindAuctionDateRequest, bindSaleNoRequest, bindSessionTimeRequest, fetchAuctionRequest } from '../../store/actions';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAuctionDetail } from '../../components/common/AunctioneerDeteailProvider';
import { ThreeDots } from 'react-loader-spinner';
import TableComponent from "../../components/tableComponent/AdminTableComponent";
import axiosMain from '../../http/axios/axios_main';
import CustomToast from '../../components/Toast';
import Modals from "../../components/common/Modal";
import { NO_OF_RECORDS } from "../../constants/commonConstants";
import { cancleNotificationByIdAction, createEditNotificationApiStatus, createNotificationDisable, createNotificationsAction, getAllNotifications, getNotificationByIdAction, getNotificationByIdActionSuccess, searchNotificationAction, updateNotificationAction } from '../../store/actions/addNotification/addNotification';
import moment from 'moment/moment';

let pageNo = 1;

const CreateNotification = ({ modalRight, open, setOpen }) => {
    const [allSaleNoList, setallSaleNoList] = useState([]);
    const [selectedNotification, setSelectedNotification] = useState('1');
    const [buyerList, setBuyerList] = useState([]);
    const [sellerList, setSellerList] = useState([]);
    const [auctioneerList, setAuctioneerList] = useState([]);
    const [expanded, setExpanded] = useState('panel1');
    const [allAuctionDate, setallAuctionDate] = useState([]);
    const [selectedAuctionDate, setSelectedAuctionDate] = useState("");
    const [allSessionTime, setallSessionTime] = useState([]);
    const [allAuctionCenterList, setallAuctionCenterList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [rows, setRows] = useState([]);
    const currentYear = new Date().getFullYear();
    const [season, setSeason] = useState(currentYear);
    const [saleNo, setSaleNo] = useState(null);
    const [auctioneer, setAuctioneer] = useState(null)
    const [seller, setSeller] = useState(null)
    const [buyer, setBuyer] = useState(null)
    const [startDateTime, setStartDateTime] = useState(null)
    const [endDateTime, setEndDateTime] = useState(null)
    const [notificationText, setNotificationText] = useState("")
    const [searchNotificationText, setSearchNotificationText] = useState(null);
    const [searchSaleNo, setSearchSaleNo] = useState(null);
    const [searchStatus, setSearchStatus] = useState(null);
    const [createdDate, setCreatedDate] = useState(null)
    const [editModal, setEditModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [editingNotificationData, setEditingNotificationData] = useState(null);
    const [mode, setMode] = useState('');
    const [displayLocationForBeforeLogin, setDisplayLocationBeforeLogin] = useState(1)
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSearchActive, setIsSearchActive] = useState(false);

    const dispatch = useDispatch();
    const { auctionCenterId } = useAuctionDetail();
    const years = [];
    for (let i = 0; i <= 5; i++) {
        const year = currentYear - i;
        years.push(year);
    }

    const [notificationFormData, setNotificationFormData] = useState({
        season: String(currentYear),
        saleNo: null,
        auctionDate: null,
        sessionTime: null,
        notificationText: null,
        buyer: null,
        seller: null,
        auctioneer: null,
        startDateTime: null,
        endDateTime: null
    });

    const radioButtonData = [
        { key: 'On Auction Page', value: '1' },
        { key: 'Before Login', value: '2' },
    ];

    const valueToKeyMap = {
        '1': 'On Auction Page',
        '2': 'Before Login'
    };

    const RoleCodes = {
        BUYER: 'BUYER',
        SELLER: 'SELLER',
        AUCTIONEER: 'AUCTIONEER'
    };

    const columns = [
        {
            name: "index",
            title: "Sr. No.",
        },
        {
            name: "notificationText",
            title: "Notification Text",
            getCellValue: (row) => (
                <a
                    href=""
                    onClick={(e) => {
                        e.preventDefault()
                        handleViewOrEditClick(row.marqueeId, "view");
                    }}
                    style={{ color: 'blue', textDecoration: 'underline' }}
                >
                    {row.notificationText}
                </a>
            ),
        },
        {
            name: "displayLocation",
            title: "Display Location",
            getCellValue: (row) => valueToKeyMap[row.displayLocation] || row.displayLocation,
        },
        {
            name: "auctionCenterName",
            title: "Display On(Auction Center)",
        },
        {
            name: "season",
            title: "Season",
            getCellValue: (row) => row.season ? row.season : "-"
        },
        {
            name: "saleNo",
            title: "Sale No.",
            getCellValue: (row) => row.saleNo ? row.saleNo : "-"
        },
        {
            name: "auctionDate",
            title: "Auction Date",
            getCellValue: (row) => row.auctionDate ? row.auctionDate : "-"
        },
        {
            name: "sessionTime",
            title: "Session Time",
            getCellValue: (row) => row.sessionTime ? row.sessionTime : "-"
        },
        {
            name: "auctioneerName",
            title: "Auctioneer",
            getCellValue: (row) => row.auctioneerId === 1 ? "All" : row.auctioneerName || "None",
        },
        {
            name: "buyerName",
            title: "Buyer",
            getCellValue: (row) => row.buyerId === 1 ? "All" : row.buyerName || "None",
        },
        {
            name: "sellerName",
            title: "Seller",
            getCellValue: (row) => row.sellerId === 1 ? "All" : row.sellerName || "None",
        },
        {
            name: "createdDate",
            title: "Creation Date",
        },
        {
            name: "isActive",
            title: "Status",
            getCellValue: (row) => {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <strong className={row.isActive === 1 ? 'Published' : 'Cancelled'}>
                            {row.isActive === 1 ? 'Published' : 'Cancelled'}
                        </strong>
                    </div>
                );
            },
        },
        {
            name: "startDate",
            title: "Start Date and Time",
            getCellValue: (rows) => formatDate(rows.startDate),
        },
        {
            name: "endDate",
            title: "End Date and Time",
            getCellValue: (rows) => formatDate(rows.endDate),
        },
        {
            name: "action",
            title: "Action",
            getCellValue: (rows) => <ActionData data={rows} />,
        },
    ];

    const handleRadioChange = (event) => {
        setSelectedNotification(event.target.value);
    };

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);

        if ("panel2" == panel && isExpanded) {
            setIsSubmitting(false);
            pageNo = 1;
            dispatch(getAllNotifications({
                pageNo: pageNo, noOfRecords: NO_OF_RECORDS
            }))
        }
    };

    const handleViewNotificationSearch = (e) => {
        const { name, value } = e.target;
        var selectedValue = value != "" ? value : null;
        setNotificationFormData({ ...notificationFormData, [name]: selectedValue });
        setSeason(notificationFormData?.season);
    };

    const handleViewMore = () => {
        pageNo = pageNo + 1;
        dispatch(getAllNotifications({
            pageNo: pageNo,
            noOfRecords: NO_OF_RECORDS,
            notificationText: searchNotificationText,
            saleNo: searchSaleNo,
            isActive: searchStatus
        }))
    }

    const saleNoData = useSelector((state) => state.saleNoReducer.saleList);
    const auctionDate = useSelector(
        (state) => state.saleNoReducer.auctionDateList
    );

    const sessionTime = useSelector(
        (state) => state.saleNoReducer.sessionTimeList
    );

    const getAllAuctionCenterList = useSelector(
        (res) => res?.warehouseUserRegistration?.auctionCenter?.responseData
    );

    const createDisable = useSelector((state) => state?.addNotification?.createdNotificationDisable)

    const createData = useSelector((state) => state?.addNotification?.createEditNotificationApiStatus)

    const selectedAuctionCenter = getAllAuctionCenterList?.find(
        (center) => center?.auctionCenterId === auctionCenterId
    );

    const allNotifications = useSelector((state) => state?.addNotification?.allNotifications.responseData)

    const allSearchNotificationData = useSelector((state) => state?.addNotification?.searchResults?.responseData)
    const ApiDataNotification = useSelector((state) => state?.addNotification?.notificationLoader);

    const editingNotificationDataFromAPI = useSelector(
        (state) => state.addNotification.notificationData?.responseData
    );

    const fetchData = () => {
        dispatch(
            searchNotificationAction({
                notificationText: searchNotificationText ? searchNotificationText : null,
                saleNo: searchSaleNo ? searchSaleNo : null,
                isActive: searchStatus ? searchStatus : null,
                pageNo: 1,
                noOfRecords: NO_OF_RECORDS
            })
        );
    };

    const handleSearch = () => {
        setLoader(true);
        setIsSearchActive(true);
        setRows([]); 
        fetchData();
    };

    useEffect(() => {
        if (allSearchNotificationData && isSearchActive) {
            const newRows = allSearchNotificationData || [];

            setRows((prevRows) => {
                const currentRows = Array.isArray(prevRows) ? [...prevRows] : [];

                newRows.forEach((newRow) => {
                    const index = currentRows.findIndex(
                        (row) => row.marqueeId === newRow.marqueeId
                    );

                    if (index !== -1) {
                        currentRows[index] = newRow;
                    } else {
                        currentRows.push(newRow);
                    }
                });

                return currentRows;
            });
        }
    }, [allSearchNotificationData]);

    function ActionData(data) {
        console.log("data..", data)
        return (
            <div class="Action">
                {modalRight?.some((ele) => ele === "2") && (
                    <Tooltip title="Edit" placement="top">
                        <i
                            className="fa fa-edit"
                            onClick={() => handleViewOrEditClick(data.data.marqueeId, "edit")}
                        ></i>
                    </Tooltip>
                )}
                {modalRight?.some((ele) => ele === "3") && (
                    <Tooltip title="View" placement="top">
                        <i
                            className="fa fa-eye"
                            onClick={() => handleViewOrEditClick(data.data.marqueeId, "view")}
                        ></i>
                    </Tooltip>
                )}
                {modalRight?.some((ele) => ele === "4") && allNotifications.some(notification => notification.marqueeId === data.data.marqueeId && notification.isActive === 1)
                    && (
                        <Tooltip title="Cancel" placement="top">
                            <i
                                className="fa fa-times"
                                onClick={() => handleCancleClick(data.data.marqueeId)}
                            ></i>
                        </Tooltip>
                    )}
            </div>
        );
    }

    const Validate = () => {
        let isValid = true;

        if ((!notificationFormData?.season && !editingNotificationData?.season) && (selectedNotification == "1" && displayLocationForBeforeLogin == "1")) {
            CustomToast.error("Please select season");
            isValid = false;
        }
        if ((!notificationFormData.saleNo && !editingNotificationData?.saleNo) && (selectedNotification == "1" && displayLocationForBeforeLogin == "1")) {
            CustomToast.error("Please select sale no");
            isValid = false;
        }
        if ((!notificationFormData.auctionDate && !editingNotificationData?.auctionDate) && (selectedNotification == "1" && displayLocationForBeforeLogin == "1")) {
            CustomToast.error("Please select Auction Date")
            isValid = false;
        }
        if ((!notificationFormData.sessionTime && !editingNotificationData?.sessionTime) && (selectedNotification == "1" && displayLocationForBeforeLogin == "1")) {
            CustomToast.error("Please select Session Time")
            isValid = false;
        }
        // if ((!notificationFormData.auctioneer && !editingNotificationData?.auctioneerId) && (selectedNotification == "1" && displayLocationForBeforeLogin == "1")) {
        //     CustomToast.error("Please select Auctioneer")
        //     isValid = false
        // }

        if (!notificationFormData.startDateTime && !editingNotificationData?.startDate) {
            CustomToast.error("Please select Start Date");
            isValid = false;
        } else {
            const currentDateTime = new Date();
            const startDateTime = new Date(notificationFormData.startDateTime || editingNotificationData?.startDate);

            if (startDateTime <= currentDateTime) {
                CustomToast.error("Start Date and Time should be greater than the current date and time");
                isValid = false;
            }
        }

        if (!notificationFormData.endDateTime && !editingNotificationData?.endDate) {
            CustomToast.error("Please select End Date and Time");
            isValid = false;
        } else {
            const startDateTime = new Date(notificationFormData.startDateTime || editingNotificationData?.startDate);
            const endDateTime = new Date(notificationFormData.endDateTime || editingNotificationData?.endDate);

            if (endDateTime <= startDateTime) {
                CustomToast.error("End Date and Time should be greater than Start Date and Time");
                isValid = false;
            }
        }
        if (!notificationFormData.notificationText && !editingNotificationData?.notificationText) {
            CustomToast.error("Please Enter Notification Text");
            isValid = false;
        } else {
            const allowedCharsPattern = /^([a-zA-Z0-9*+/\-@# !,",.()%()]){1,5000}$/;
            if (!allowedCharsPattern.test(notificationFormData.notificationText)) {
                CustomToast.error("Notification text should be up to 5000 characters and only contain alphanumeric characters and the following special characters: * + - @ / space # ! \" , . % ( )");
                isValid = false;
            }
        }

        return isValid;
    };

    const fetchUsersByRole = async (roleCode) => {
        try {
            const response = await axiosMain.get(`/admin/user/auctionCenter/${auctionCenterId}/roleCode/${roleCode}`);
            const data = response.data;

            if (data.statusCode === 200 && Array.isArray(data.responseData)) {
                return data.responseData;
            } else {
                console.error("No data received:", data.message);
                return [];
            }

        } catch (error) {
            console.error(`Error fetching ${roleCode} data:`, error);
            return [];
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        if (Validate()) {
            const payload = {
                displayLocation: selectedNotification,
                auctionCenterId: auctionCenterId,
                season: notificationFormData?.season,
                saleNo: notificationFormData?.saleNo,
                auctionDate: notificationFormData?.auctionDate,
                sessionTime: notificationFormData?.sessionTime,
                auctioneerId: notificationFormData?.auctioneer,
                buyerId: notificationFormData?.buyer,
                sellerId: notificationFormData?.seller,
                notificationText: notificationFormData?.notificationText?.trim(),
                startDate: notificationFormData?.startDateTime,
                endDate: notificationFormData?.endDateTime,
                isActive: 1,
                searchData: {
                    pageNo: 1,
                    noOfRecords: NO_OF_RECORDS,
                },
            }
            setIsSubmitting(true);
            if (editingNotificationData) {
                dispatch(updateNotificationAction(editingNotificationData));
                // handleCloseViewOrEditModal();
            } else {
                dispatch(createNotificationsAction(payload));
            }
        }
        else {
            console.log("failed")
        }
    }

    const handleViewOrEditClick = (marqueeId, mode) => {
        dispatch(getNotificationByIdAction(marqueeId));
        // setViewMode(false);
        // setExpanded("panel1");
        setMode(mode);
        if (mode == 'edit') {
            setEditModal(true);
        } else {
            setViewModal(true);
        }

    };

    const handleCancleClick = (marqueeId) => {
        dispatch(cancleNotificationByIdAction(marqueeId))
        setLoader(true)
        setTimeout(() => {
            setLoader(false);
            if (searchNotificationText || searchSaleNo || searchStatus) {
                fetchData();
            } else {
                dispatch(getAllNotifications({
                    pageNo: pageNo, noOfRecords: NO_OF_RECORDS
                }))
            }
        }, 1000);
    }

    const handleCloseViewOrEditModal = () => {
        if (mode === 'edit') {
            setEditModal(false);
        } else {
            setViewModal(false);
        }

        if (searchNotificationText || searchSaleNo || searchStatus) {
            fetchData();
        } else {
            dispatch(getAllNotifications({
                pageNo: pageNo, noOfRecords: NO_OF_RECORDS
            }))
        }
        //updated
        setEditingNotificationData(null);
        // clearSearch();
        // handleClear();
    };

    const resetForm = () => {
        setNotificationFormData({})
    }

    const clearSearchPage = () => {
        setSearchNotificationText(null);
        setSearchSaleNo(null);
        setSearchStatus(null);
        setRows([]);
        pageNo = 1;
        setLoader(true)
        // dispatch(getAllNotifications())
        setTimeout(() => {
            setLoader(false);
            dispatch(getAllNotifications({ pageNo: pageNo, noOfRecords: NO_OF_RECORDS }));
        }, 1000);
    }

    const formatDate = (dateString) => {
        return moment(dateString).format('MM/DD/YYYY hh:mm A');  // Format date in the desired format
    };

    useEffect(() => {
        if (open === "") {
            setRows([])
            setIsSearchActive(false);
            clearSearchPage()
        }
    }, [open])

    useEffect(() => {
        if (notificationFormData?.season !== "") {
            dispatch(
                bindSaleNoRequest({
                    season: notificationFormData?.season,
                    auctionCenterId: auctionCenterId,
                })
            );
        }
    }, [notificationFormData?.season]);

    useEffect(() => {
        if (notificationFormData.saleNo !== null) {
            dispatch(
                bindAuctionDateRequest({
                    season: notificationFormData?.season,
                    saleNo: notificationFormData.saleNo,
                    auctionCenterId: auctionCenterId,
                })
            );
        }
    }, [notificationFormData.saleNo]);

    useEffect(() => {
        if (notificationFormData.auctionDate !== null) {
            dispatch(
                bindSessionTimeRequest({
                    season: notificationFormData?.season,
                    saleNo: notificationFormData.saleNo,
                    auctionDate: notificationFormData.auctionDate,
                    auctionCenterId: auctionCenterId,
                    auctioneerId: 0
                })
            );
        }
    }, [notificationFormData.auctionDate]);

    useEffect(() => {
        if (editingNotificationData) {
            dispatch(bindSaleNoRequest({
                season: editingNotificationData?.season,
                auctionCenterId: auctionCenterId,
            }
            ));
            dispatch(bindAuctionDateRequest({
                season: editingNotificationData?.season,
                saleNo: editingNotificationData?.saleNo,
                auctionCenterId: auctionCenterId,
            }));
            dispatch(bindSessionTimeRequest({
                season: editingNotificationData?.season,
                saleNo: editingNotificationData?.saleNo,
                auctionDate: editingNotificationData?.auctionDate,
                auctionCenterId: auctionCenterId,
                auctioneerId: 0
            }
            ))
        }
    }, [editingNotificationData?.season, editingNotificationData?.saleNo, editingNotificationData?.auctionDate])

    useEffect(() => {
        setallSaleNoList(saleNoData)
        setallAuctionDate(auctionDate);
        setallSessionTime(sessionTime);
        setallAuctionCenterList(getAllAuctionCenterList);
    }, [saleNoData, auctionDate, sessionTime, getAllAuctionCenterList])

    useEffect(() => {
        const newRows = allNotifications || [];
        setRows((prevRows) => {
            const currentRows = Array.isArray(prevRows) ? [...prevRows] : [];

            newRows.forEach((newRow) => {
                const index = currentRows.findIndex(
                    (row) => row.marqueeId === newRow.marqueeId
                );

                if (index !== -1) {
                    currentRows[index] = newRow;
                } else {
                    currentRows.push(newRow);
                }
            });

            return currentRows;
        });
    }, [allNotifications]);

    useEffect(() => {
        dispatch(fetchAuctionRequest());
    }, [])

    useEffect(() => {
        if (true == createDisable) {
            setIsSubmitting(false);
        }
    });

    useEffect(() => {
        if (true == createData && createDisable) {
            dispatch(createEditNotificationApiStatus(false))
            dispatch(createNotificationDisable(false))
            resetForm()
            clearSearchPage()
            setIsSubmitting(false);
            dispatch(getAllNotifications({ pageNo: pageNo, noOfRecords: NO_OF_RECORDS }))
            dispatch(getNotificationByIdActionSuccess([]))
            setExpanded("panel2");
            setEditingNotificationData(null);
            setEditModal(false);
            setViewModal(false);
        } else if (true == createData) {
            dispatch(createEditNotificationApiStatus(false))
            dispatch(getNotificationByIdActionSuccess([]))
            setExpanded("panel2");
            resetForm();
            setIsSubmitting(false);
            setEditingNotificationData(null);
            handleCloseViewOrEditModal();
            setEditModal(false);
            setViewModal(false);
        }
    });

    useEffect(() => {
        const loadDropdownData = async () => {
            const [buyers, sellers, auctioneers] = await Promise.all([
                fetchUsersByRole(RoleCodes.BUYER),
                fetchUsersByRole(RoleCodes.SELLER),
                fetchUsersByRole(RoleCodes.AUCTIONEER)
            ]);
            setBuyerList(buyers);
            setSellerList(sellers);
            setAuctioneerList(auctioneers);
        };

        loadDropdownData();
    }, []);

    useEffect(() => {
        console.log("editingFormData", editingNotificationDataFromAPI)
        if (editingNotificationDataFromAPI) {
            // Format the auctionDate to match the date-only format (YYYY-MM-DD)
            const formattedAuctionDate = editingNotificationDataFromAPI.auctionDate
                ? editingNotificationDataFromAPI.auctionDate.split("T")[0]
                : "";

            const formattedCreatedDate = editingNotificationDataFromAPI.createdDate
                ? editingNotificationDataFromAPI.createdDate.split("T")[0]
                : "";

            const buyer = buyerList.find(b => b.userId === editingNotificationDataFromAPI.buyerId);
            const seller = sellerList.find(s => s.userId === editingNotificationDataFromAPI.sellerId);
            const auctioneer = auctioneerList.find(a => a.userId === editingNotificationDataFromAPI.auctioneerId);

            setEditingNotificationData(editingNotificationDataFromAPI);
            setSeason(editingNotificationDataFromAPI?.season || "");
            setSaleNo(editingNotificationDataFromAPI?.saleNo || "");
            setallAuctionCenterList(editingNotificationDataFromAPI?.auctionCenter || "")
            setSelectedAuctionDate(formattedAuctionDate || "");
            setallSessionTime([editingNotificationDataFromAPI?.sessionTime] || "")
            setBuyer(buyer ? buyer.userName : '');
            setSeller(seller ? seller.userName : '');
            setAuctioneer(auctioneer ? auctioneer.userName : '');
            setStartDateTime(editingNotificationDataFromAPI?.startDate || "")
            setEndDateTime(editingNotificationDataFromAPI?.endDate || "")
            setNotificationText(editingNotificationDataFromAPI?.notificationText || '')
            setCreatedDate(formattedCreatedDate || '')
            setDisplayLocationBeforeLogin(editingNotificationDataFromAPI?.displayLocation || "")
        }
    }, [editingNotificationDataFromAPI, buyerList, sellerList, auctioneerList]);

    useEffect(() => {
        if (true == ApiDataNotification) {
            setTimeout(() => {
                setLoader(false);
                pageNo = pageNo;
            }, 1000);
        }
    });


    return (
        <>
            {Array.isArray(modalRight) && modalRight.some((ele) => ele === "1") && (
                <Accordion
                    expanded={expanded === "panel1"}
                    className={`${expanded === "panel1" ? "active" : ""}`}
                    onChange={handleChange("panel1")}
                    TransitionProps={{ unmountOnExit: true }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Create Notification</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    {/* Radio Buttons */}
                                    <div className="row align-items-center mb-3">
                                        <div className="col-md-12 d-flex CheckboxGroup">
                                            {radioButtonData.map((data, index) => (
                                                <div className="form-check mr-4" key={index}>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="notificationType"
                                                        id={data.key}
                                                        value={data.value}
                                                        checked={selectedNotification === data.value}
                                                        onChange={handleRadioChange}
                                                    />
                                                    <label className="form-check-label" htmlFor={data.key}>
                                                        {data.key}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="row ">
                                        {selectedNotification === "1" && (
                                            <>
                                                <div className="col-md-4 mb-3">
                                                    <div className="FormGroup">
                                                        <label>Auction Center</label>
                                                        <label className="errorLabel"> * </label>
                                                        <div
                                                            className="form-control bg-light"
                                                            style={{ pointerEvents: "none", height: "38px", display: "flex", alignItems: "center", paddingLeft: "10px" }}
                                                        >
                                                            {selectedAuctionCenter?.auctionCenterName || ""}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Season Dropdown */}
                                                <div className="col-md-4 mb-3">
                                                    <div className="FormGroup">
                                                        <label>Season</label>
                                                        <label className="errorLabel"> * </label>
                                                        <select
                                                            className="form-control select-form"
                                                            name="season"
                                                            value={notificationFormData?.season || ""}
                                                            onChange={handleViewNotificationSearch}>
                                                            <option value="">Select Season</option>
                                                            {years.map((year) => (
                                                                <option key={year} value={year}>
                                                                    {year}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Sale No. Dropdown */}
                                                <div className="col-md-4 mb-3">
                                                    <div className="FormGroup">
                                                        <label>Sale No</label>
                                                        <label className="errorLabel"> * </label>
                                                        <select
                                                            name="saleNo"
                                                            className="form-control select-form"
                                                            onChange={handleViewNotificationSearch}
                                                            value={notificationFormData.saleNo || ""}
                                                        >
                                                            <option value="">Select Sale No</option>
                                                            {allSaleNoList.map((saleNoItem, index) => (
                                                                <option value={saleNoItem.saleNo} key={index}>
                                                                    {saleNoItem.saleNo}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    <div className="row ">
                                        {selectedNotification === "1" && (
                                            <div className="col-md-4 mb-3">
                                                <div className="FomrGroup">
                                                    <label>Auction Date </label>
                                                    <label className="errorLabel"> * </label>
                                                    <select
                                                        name="auctionDate"
                                                        value={notificationFormData.auctionDate || ""}
                                                        className="form-control select-form"
                                                        onChange={handleViewNotificationSearch}
                                                    >
                                                        <option value="">Select Auction Date </option>
                                                        {allAuctionDate?.map((allAuctionDate, index) => (
                                                            <option value={allAuctionDate?.saleDate}>
                                                                {allAuctionDate?.saleDate}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {selectedNotification === "1" && (
                                            <div className="col-md-4 mb-3">
                                                <div className="FomrGroup">
                                                    <label>Session Time</label>
                                                    <label className="errorLabel"> * </label>
                                                    <select
                                                        name="sessionTime"
                                                        value={notificationFormData?.sessionTime || ""}
                                                        className="form-control select-form"
                                                        onChange={handleViewNotificationSearch}
                                                    >
                                                        <option value="">Select Session Time </option>
                                                        {allSessionTime?.map((allSessionTime, index) => (
                                                            <option value={allSessionTime?.SessionTime}>
                                                                {allSessionTime?.SessionTime}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                        )}

                                        {selectedNotification == "1" && (
                                            <div className="col-md-4 mb-3">
                                                <div className="FormGroup">
                                                    <label>Auctioneer</label>
                                                    <label className="errorLabel"> * </label>
                                                    <select className="form-control select-form" name="auctioneer" value={notificationFormData.auctioneer || ""} onChange={handleViewNotificationSearch}>
                                                        <option value="">None</option>
                                                        <option value="1">All</option>
                                                        {auctioneerList?.map((auctioneer) => (
                                                            <option key={auctioneer.userId} value={auctioneer.userId}>{auctioneer.userName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="row ">
                                        {/* Buyer Dropdown */}
                                        {selectedNotification == "1" && (
                                            <div className="col-md-4 mb-3">
                                                <div className="FormGroup">
                                                    <label>Buyer</label>
                                                    <label className="errorLabel"> * </label>
                                                    <select className="form-control select-form" name='buyer' value={notificationFormData.buyer || ""} onChange={handleViewNotificationSearch}>
                                                        <option value="">None</option>
                                                        <option value="1">All</option>
                                                        {buyerList.map((buyer) => (
                                                            <option key={buyer.userId} value={buyer.userId}>{buyer.userName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {/* Seller Dropdown */}
                                        {selectedNotification == "1" && (
                                            <div className="col-md-4 mb-3">
                                                <div className="FormGroup">
                                                    <label>Seller</label>
                                                    <label className="errorLabel"> * </label>
                                                    <select className="form-control select-form" name='seller' value={notificationFormData.seller || ""} onChange={handleViewNotificationSearch}>
                                                        <option value="">None</option>
                                                        <option value="1">All</option>
                                                        {sellerList?.map((seller) => (
                                                            <option key={seller.userId} value={seller.userId}>{seller.userName}</option>
                                                        ))}

                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        <div className="col-md-4 mb-3">
                                            <div className="FormGroup" style={{ display: "flex", flexDirection: 'column' }}>
                                                <div style={{ display: "flex", flexDirection: 'row' }}>
                                                    <label>Start Date & Time</label>
                                                    <label className="errorLabel"> * </label>
                                                </div>
                                                <input type="datetime-local" className="custom-datetime-input"
                                                    name='startDateTime'
                                                    value={notificationFormData.startDateTime || ""}
                                                    onChange={handleViewNotificationSearch}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-md-4 mb-3">
                                            <div className="FormGroup" style={{ display: "flex", flexDirection: 'column' }}>
                                                <div style={{ display: "flex", flexDirection: 'row' }}>
                                                    <label>End Date & Time</label>
                                                    <label className="errorLabel"> * </label>
                                                </div>
                                                <input type="datetime-local" className="custom-datetime-input"
                                                    name='endDateTime'
                                                    value={notificationFormData.endDateTime || ""}
                                                    onChange={handleViewNotificationSearch}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-md-8 mb-3">
                                            <div className="FormGroup">
                                                <label>Notification On Text</label>
                                                <label className="errorLabel"> * </label>
                                                <textarea
                                                    className="form-control"
                                                    rows="2"
                                                    name='notificationText'
                                                    value={notificationFormData.notificationText || ""}
                                                    onChange={handleViewNotificationSearch}
                                                    style={{
                                                        minHeight: "100px",
                                                        resize: "vertical",
                                                        overflow: "auto",
                                                    }}
                                                ></textarea>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 ">
                                            <div className="BtnGroup">
                                                <button
                                                    className="SubmitBtn"
                                                    type='submit'
                                                    disabled={isSubmitting}
                                                >
                                                    Submit
                                                </button>

                                                <button
                                                    type='button'
                                                    className="Clear"
                                                    onClick={resetForm}

                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </AccordionDetails>
                </Accordion>
            )}

            {modalRight?.some((ele) => ele === "12") && (
                <Accordion
                    expanded={expanded === "panel2"}
                    className={`${expanded === "panel2" ? "active" : ""}`}
                    onChange={handleChange("panel2")}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <Typography>Manage Notification</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row align-items-end">
                                        <div className="col-md-4">
                                            <div className="FormGroup">
                                                <label>Notification Text</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={searchNotificationText || ""}
                                                    onChange={(e) => setSearchNotificationText(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="FormGroup">
                                                <label>Sale No</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={searchSaleNo || ""}
                                                    onChange={(e) =>
                                                        setSearchSaleNo(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="FormGroup">
                                                <label>Notification Status</label>
                                                <select
                                                    className="form-control select-form"
                                                    onChange={(e) => setSearchStatus(e.target.value)}
                                                    value={searchStatus ?? ""}
                                                >
                                                    <option value="">Select Status </option>
                                                    <option value="1">Published </option>
                                                    <option value="0">Cancelled</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="BtnGroup">
                                                <button
                                                    className="SubmitBtn"
                                                    onClick={() => handleSearch()}
                                                >
                                                    Search
                                                </button>
                                                <button className="Clear"
                                                    onClick={clearSearchPage}
                                                >
                                                    Clear
                                                </button>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12 mt-4">
                                    <div className="TableBox CreateStateMaster">
                                        {loader ? (
                                            <div className="">
                                                <ThreeDots
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    color="#4fa94d"
                                                    radius="9"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass=""
                                                />
                                            </div>
                                        ) : (allNotifications?.length == 0 || rows?.length == 0) ? (
                                            <div className="NoData">No Records Found</div>
                                        ) : rows?.length > 0 ? (
                                            <TableComponent
                                                columns={columns}
                                                rows={rows?.map((row, index) => ({
                                                    ...row,
                                                    index: index + 1,
                                                }))}
                                                sorting={true}
                                                dragdrop={false}
                                                fixedColumnsOn={false}
                                                resizeingCol={false}
                                            />
                                        ) : null}
                                    </div>

                                    {
                                        rows?.length >= 20 && (
                                            <button
                                                class="SubmitBtn"
                                                onClick={handleViewMore}
                                                disabled={
                                                    !rows || rows.length % 20 !== 0 || rows.length <= 0
                                                }
                                            >
                                                View More
                                            </button>
                                        )
                                    }

                                </div>
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            )}

            {mode ? (
                <Modals
                    title={mode === "view" ? "View Notification" : "Edit Notification"}
                    show={mode === "view" ? viewModal : editModal}
                    handleClose={handleCloseViewOrEditModal}
                    size="xl"
                    centered
                >
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12 mb-3">
                                <div className="row ">
                                    {displayLocationForBeforeLogin == "1" && (
                                        <>
                                            <div className="col-md-4 mb-3">
                                                <div className="FormGroup">
                                                    <label>Auction Center</label>
                                                    <label className="errorLabel"> * </label>
                                                    <div
                                                        className="form-control"
                                                        disabled={viewModal}
                                                        style={{ pointerEvents: "none", height: "38px", display: "flex", alignItems: "center", paddingLeft: "10px", backgroundColor: viewModal ? "#e9ecef" : "" }}
                                                    >
                                                        {editingNotificationData?.auctionCenterName || ""}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Season Dropdown */}
                                            <div className="col-md-4 mb-3">
                                                <div className="FormGroup">
                                                    <label>Season</label>
                                                    <label className="errorLabel"> * </label>
                                                    <select
                                                        className="form-control select-form"
                                                        name="season"
                                                        value={editingNotificationData?.season}
                                                        disabled={viewModal}
                                                        onChange={(e) =>
                                                        (editingNotificationData
                                                            ? setEditingNotificationData({
                                                                ...editingNotificationData,
                                                                season: e.target.value,
                                                            })
                                                            : setSeason(e.target.value))
                                                        }>
                                                        <option value="">Select Season</option>
                                                        {years.map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Sale No. Dropdown */}
                                            <div className="col-md-4 mb-3">
                                                <div className="FormGroup">
                                                    <label>Sale No</label>
                                                    <label className="errorLabel"> * </label>
                                                    <select
                                                        name="saleNo"
                                                        className="form-control select-form"
                                                        disabled={viewModal}
                                                        onChange={(e) =>
                                                        (editingNotificationData
                                                            ? setEditingNotificationData({
                                                                ...editingNotificationData,
                                                                saleNo: e.target.value,
                                                            })
                                                            : setSaleNo(e.target.value))
                                                        }
                                                        value={editingNotificationData?.saleNo}
                                                    >
                                                        <option value="">Select Sale No</option>
                                                        {allSaleNoList.map((saleNoItem, index) => (
                                                            <option value={saleNoItem.saleNo} key={index}>
                                                                {saleNoItem.saleNo}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                        </>
                                    )}
                                </div>

                                <div className="row ">
                                    {displayLocationForBeforeLogin == "1" && (
                                        <div className="col-md-4 mb-3">
                                            <div className="FomrGroup">
                                                <label>Auction Date </label>
                                                <label className="errorLabel"> * </label>
                                                <select
                                                    name="auctionDate"
                                                    value={selectedAuctionDate}
                                                    className="form-control select-form"
                                                    disabled={viewModal}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedAuctionDate(value);
                                                        if (editingNotificationData) {
                                                            setEditingNotificationData({
                                                                ...editingNotificationData,
                                                                auctionDate: value,
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <option value="">Select Auction Date </option>
                                                    {allAuctionDate?.map((allAuctionDate, index) => (
                                                        <option value={allAuctionDate?.saleDate}>
                                                            {allAuctionDate?.saleDate}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {displayLocationForBeforeLogin == "1" && (
                                        <div className="col-md-4 mb-3">
                                            <div className="FomrGroup">
                                                <label>Session Time</label>
                                                <label className="errorLabel"> * </label>
                                                <select
                                                    name="sessionTime"
                                                    value={editingNotificationData?.sessionTime}
                                                    className="form-control select-form"
                                                    disabled={viewModal}
                                                    onChange={(e) =>
                                                    (editingNotificationData
                                                        ? setEditingNotificationData({
                                                            ...editingNotificationData,
                                                            sessionTime: e.target.value,
                                                        })
                                                        : setallSessionTime(e.target.value))
                                                    }>
                                                    <option value="">Select Session Time </option>
                                                    {allSessionTime?.map((allSessionTime, index) => (
                                                        <option value={allSessionTime.SessionTime}>
                                                            {allSessionTime.SessionTime}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {displayLocationForBeforeLogin == "1" && (
                                        <div className="col-md-4 mb-3">
                                            <div className="FormGroup">
                                                <label>Auctioneer</label>
                                                <label className="errorLabel"> * </label>
                                                <select className="form-control select-form" name="auctioneerName"
                                                    value={editingNotificationData?.auctioneerId}
                                                    disabled={viewModal}
                                                    onChange={(e) =>
                                                    (editingNotificationData
                                                        ? setEditingNotificationData({
                                                            ...editingNotificationData,
                                                            auctioneerId: e.target.value,
                                                        })
                                                        : setAuctioneer(e.target.value))
                                                    }>
                                                    <option value="">None</option>
                                                    <option value="1">All</option>
                                                    {auctioneerList?.map((auctioneer) => (
                                                        <option key={auctioneer.userId} value={auctioneer.userId}>{auctioneer.userName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="row ">
                                    {/* Buyer Dropdown */}
                                    {displayLocationForBeforeLogin == "1" && (
                                        <div className="col-md-4 mb-3">
                                            <div className="FormGroup">
                                                <label>Buyer</label>
                                                <label className="errorLabel"> * </label>
                                                <select className="form-control select-form" name='buyer'
                                                    value={editingNotificationData?.buyerId}
                                                    disabled={viewModal}
                                                    onChange={(e) =>
                                                    (editingNotificationData
                                                        ? setEditingNotificationData({
                                                            ...editingNotificationData,
                                                            buyerId: e.target.value,
                                                        })
                                                        : setBuyer(e.target.value))
                                                    }>
                                                    <option value="">None</option>
                                                    <option value="1">All</option>
                                                    {buyerList.map((buyer) => (
                                                        <option key={buyer.userId} value={buyer.userId}>{buyer.userName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {/* Seller Dropdown */}
                                    {displayLocationForBeforeLogin == "1" && (
                                        <div className="col-md-4 mb-3">
                                            <div className="FormGroup">
                                                <label>Seller</label>
                                                <label className="errorLabel"> * </label>
                                                <select className="form-control select-form" name='seller'
                                                    value={editingNotificationData?.sellerId}
                                                    disabled={viewModal}
                                                    onChange={(e) =>
                                                    (editingNotificationData
                                                        ? setEditingNotificationData({
                                                            ...editingNotificationData,
                                                            sellerId: e.target.value,
                                                        })
                                                        : setSeller(e.target.value))
                                                    }>
                                                    <option value="">None</option>
                                                    <option value="1">All</option>
                                                    {sellerList?.map((seller) => (
                                                        <option key={seller.userId} value={seller.userId}>{seller.userName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    <div className="col-md-4 mb-3">
                                        <div className="FormGroup" style={{ display: "flex", flexDirection: 'column' }}>
                                            <div style={{ display: "flex", flexDirection: 'row' }}>
                                                <label>Start Date & Time</label>
                                                <label className="errorLabel"> * </label>
                                            </div>
                                            <input type="datetime-local" className="custom-datetime-input" style={{ backgroundColor: viewModal ? "#e9ecef" : "" }}
                                                name='startDateTime'
                                                value={editingNotificationData?.startDate}
                                                disabled={viewModal}
                                                onChange={(e) =>
                                                (editingNotificationData
                                                    ? setEditingNotificationData({
                                                        ...editingNotificationData,
                                                        startDate: e.target.value,
                                                    })
                                                    : setStartDateTime(e.target.value))
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className="col-md-4 mb-3">
                                        <div className="FormGroup" style={{ display: "flex", flexDirection: 'column' }}>
                                            <div style={{ display: "flex", flexDirection: 'row' }}>
                                                <label>End Date & Time</label>
                                                <label className="errorLabel"> * </label>
                                            </div>
                                            <input type="datetime-local" className="custom-datetime-input" style={{ backgroundColor: viewModal ? "#e9ecef" : "" }}
                                                name='endDateTime'
                                                value={editingNotificationData?.endDate}
                                                disabled={viewModal}
                                                onChange={(e) =>
                                                (editingNotificationData
                                                    ? setEditingNotificationData({
                                                        ...editingNotificationData,
                                                        endDate: e.target.value,
                                                    })
                                                    : setEndDateTime(e.target.value))
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <div className="FormGroup">
                                            <label>Created Date</label>
                                            <label className="errorLabel"> * </label>
                                            <div
                                                className="form-control"
                                                style={{ pointerEvents: "none", height: "38px", display: "flex", alignItems: "center", paddingLeft: "10px", backgroundColor: viewModal ? "#e9ecef" : "" }}
                                                disabled={viewModal}
                                            >
                                                {createdDate || ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-md-8 mb-3">
                                        <div className="FormGroup">
                                            <label>Notification On Text</label>
                                            <label className="errorLabel"> * </label>
                                            <textarea
                                                className="form-control"
                                                rows="2"
                                                name='notificationText'
                                                value={editingNotificationData?.notificationText}
                                                disabled={viewModal}
                                                onChange={(e) =>
                                                (editingNotificationData
                                                    ? setEditingNotificationData({
                                                        ...editingNotificationData,
                                                        notificationText: e.target.value,
                                                    })
                                                    : setNotificationText(e.target.value))
                                                }
                                                style={{
                                                    minHeight: "100px",
                                                    resize: "vertical",
                                                    overflow: "auto",
                                                }}
                                            ></textarea>

                                        </div>
                                    </div>
                                </div>
                                {mode === "edit" && (
                                    <div className="row">
                                        <div className="col-md-12 ">
                                            <div className="BtnGroup">
                                                <button
                                                    className="SubmitBtn"
                                                    type='submit'
                                                // onClick={handleSubmit}
                                                // disabled={isSubmitting}
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}


                            </div>
                        </div>
                    </form>
                </Modals>
            ) : (
                ""
            )}
        </>
    );
};

export default CreateNotification;
